import styled from '@emotion/styled'
import Flex from 'shared/library/atoms/Flex'
import { H6, Text } from 'library/atoms/Typography'
import useTranslation from 'next-translate/useTranslation'
import Price, {
  PriceProps,
  PriceText,
  PriceWrapper
} from 'shared/library/atoms/Price'
import FieldHolder from 'library/atoms/FieldHolder'
import Quantity, { QuantityProps } from '../Quantity'

export interface PersonGoingInputProps
  extends Partial<Pick<PriceProps, 'pence' | 'currency'>>,
    Pick<QuantityProps, 'name' | 'max' | 'incrementInactive'> {
  type: 'adults' | 'children'
  maxChildAge?: number
  gaid?: string
}

const PersonGoingInput = ({
  gaid,
  type,
  maxChildAge,
  pence,
  currency,
  name,
  max,
  incrementInactive
}: PersonGoingInputProps) => {
  const { t } = useTranslation('chargeable')

  return (
    <StyledFieldHolder>
      <StyledLabel htmlFor={name}>
        <Flex flexDirection="column" width={1}>
          <H6>
            {t(`common:${type}`)}
            {maxChildAge
              ? ` (${t('under-age-x', {
                  count: maxChildAge
                })})`
              : undefined}
          </H6>
          {!!pence && !!currency && (
            <StyledPriceText as="div">
              <PriceWrapper color="tertiary">
                <Price pence={pence} currency={currency} />
                <PriceText color="tertiary"> each</PriceText>
              </PriceWrapper>
            </StyledPriceText>
          )}
        </Flex>
      </StyledLabel>
      <Quantity
        gaid={gaid}
        name={name}
        min={0}
        max={max}
        incrementAriaLabel={t(`increase-${type}-going`)}
        decrementAriaLabel={t(`decrease-${type}-going`)}
        incrementInactive={incrementInactive}
      />
    </StyledFieldHolder>
  )
}

export default PersonGoingInput

const StyledPriceText = styled(Text)(() => ({
  marginBottom: 0,
  // the price in this component doesn't have to be bold
  b: {
    fontWeight: 'normal' as const
  }
}))

const StyledFieldHolder = styled(FieldHolder)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: 'auto',
  padding: theme.space[4],
  marginBottom: theme.space[4]
}))

const StyledLabel = styled.label(() => ({
  display: 'flex',
  alignItems: 'center'
}))
